/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import { FORGOT_PASSWORD_ENDPOINT_SUFFIX, AUTH_CONFIG } from '../config/auth0';
// const SUBMIT_USER_HOOK = `https://hooks.zapier.com/hooks/catch/599828/o5b8alo/`;
const GOOGLE_MAPS_API = `AIzaSyBCqiNyShGwMn7eQYvJC6NPc0JS9ihcjkg`;

export const getLocationData = async (latitude, longitude) => {
  const res = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${latitude},${longitude}&key=${GOOGLE_MAPS_API}&result_type=administrative_area_level_1&language=en`
  );
  const json = await res.json();

  const provinceDetail = json.results[0].address_components.filter((addressComponent) =>
    addressComponent.types.includes('administrative_area_level_1')
  );

  const countryDetail = json.results[0].address_components.filter((addressComponent) =>
    addressComponent.types.includes('country')
  );

  const value = {
    provinceName: 'Not Available',
    countryName: 'Not Available',
    countryCode: 'Not Available',
  };

  if (provinceDetail && provinceDetail.length > 0 && provinceDetail[0].long_name) {
    value.provinceName = provinceDetail[0].long_name;
  }

  if (countryDetail && countryDetail.length > 0) {
    if (countryDetail[0].long_name) {
      value.countryName = countryDetail[0].long_name;
    }
    if (countryDetail[0].short_name) {
      value.countryCode = countryDetail[0].short_name;
    }
  }

  return value;
};

export const postForgotPasswordApiCall = async (targetEmail) => {
  try {
    const { clientID, connection, domain } = AUTH_CONFIG;
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ client_id: clientID, connection, email: targetEmail }),
    };
    const targetUrl = `https://${domain}${FORGOT_PASSWORD_ENDPOINT_SUFFIX}`;
    const response = await window.fetch(targetUrl, config);
    const data = (await response.status) === 200;
    return data;
  } catch (e) {
    console.error('ERROR: ', e);
    return e;
  }
};

export const listProvinces = () => {
  const provinces = [
    "Badakhshan",
    "Badghis",
    "Baghlan",
    "Balkh",
    "Bamyan",
    "Daykundi",
    "Farah",
    "Faryab",
    "Ghazni",
    "Ghor",
    "Helmand",
    "Herat",
    "Kabul",
    "Kandahar",
    "Kapisa",
    "Khost",
    "Kunar",
    "Kunduz",
    "Laghman",
    "Logar",
    "Nangarhar",
    "Nimruz",
    "Nuristan",
    "Paktia",
    "Paktika",
    "Panjshir",
    "Parwan",
    "Samangan",
    "Sar-e Pol",
    "Takhar",
    "Urozgan",
    "Wardak",
    "Zabul",
    "Other"
  ]

  const dataProvinces = provinces.map((item) => {
    return {label: item, value: item}
  })

  return dataProvinces;
}

export const postSubmitAnswerAPICall = async (requestData) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: JSON.stringify({...requestData })
    }
    const response = await window.fetch('https://hooks.zapier.com/hooks/catch/599828/bam3bpg/', config)
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw Error(`Response is not a JSON.`);
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e)
    return e
  }
}